export default __webpack_public_path__ + "static/media/03.f465e278.webp";